import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { MoneyHelper } from '@shared';
import { DEFAULT_DECIMAL_PLACES, fixedDigitsInfo } from '@shared/models/decimal-places';

/**
 * "10.250" — a quantity painted with exactly `decimals` fraction digits (en-US grouping).
 * Screens that follow the organisation's Decimal Places setting pass `DecimalPlacesService.current.quantity`;
 * the rest keep the three decimals the pipe always painted.
 */
@Pipe({
  name: 'quantityFormatterV3'
})
export class QuantityFormatterV3Pipe implements PipeTransform {

  locale = 'en-US';

  constructor(private moneyHelper: MoneyHelper) { }

  transform(value: number, decimals: number = DEFAULT_DECIMAL_PLACES.quantity) {
    return formatNumber(
      this.moneyHelper.round(value, decimals),
      this.locale,
      fixedDigitsInfo(decimals)
    );
  }

}
